// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import Echarts from 'echarts';
// import G2 from '@antv/g2';
import {
  getStore,
  HOST,
  setStore
} from './config/mUtils'
import { mobile } from './config/fontSize'
//引入element-ui的默认CSS样式
Vue.config.productionTip = false;
import "babel-polyfill";
import './assets/styles/reset.css';
/* eslint-disable no-new */
axios.defaults.baseURL = HOST;
// axios.defaults.transformRequest = [
//   function (data) {
//     let ret = "";
//     for (let it in data) {
//       ret +=
//         encodeURIComponent(it) +
//         "=" +
//         encodeURIComponent(data[it]) +
//         "&";
//     }
//     return ret;
//   }
// ];
// console.log(HOST,'HOST')
/* eslint-disable no-new */

// 引入Vuex的store
import store from './Vuex'
import $ from 'jquery'
mobile();
Vue.use(Echarts);
import axios from 'axios'
import {
  post,
  fetch
} from './config/http'
//定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$fetch = fetch;
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
});
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) { // 下一个页面需要登录
    if (getStore("stageToken")) { // 已登录
      next() // 访问下一个页面
    } else { // 未登录
      next('') // 回到登录界面
    }
  } else { //下一个页面不需要登录
    next() // 访问下一个页面
  }
});




// WEBPACK FOOTER //
// ./src/main.js